import React from 'react';

import { Country } from '@work4all/models/lib/Classes/Country.entity';

import { EntityTableV8, IEntityTableV8 } from '../entity-table/EntityTableV8';
import { useEntityDataTableV8 } from '../entity-table/use-entity-data-table-v8';
import schema from '../schemata/country-table-schema.json';
import { TaxKeyCell } from '../table/TaxKeyCell';

export const CountryTable = (props: IEntityTableV8) => {
  const { entity: entityType } = schema as never;

  const dataTable = useEntityDataTableV8<Country, never>({
    ...props,
    schema: schema as never,
    cells: {
      TaxKey: TaxKeyCell,
    },
  });

  return (
    <EntityTableV8
      entityType={entityType}
      {...dataTable}
      {...props}
      actions={{
        groupingEnabled: false,
        createWidget: false,
      }}
      overrides={{
        areas: {
          left: null,
          right: null,
        },
      }}
    />
  );
};
